export default __webpack_public_path__ + "static/media/icon-nguvan.5f91fb18.svg";